import { observable } from 'mobx';
import { IInstance } from '../../../interfaces/IInstance';
import { IFontSlots } from '../../../interfaces/IFontSlots';

export class ContentMapExtensionStore {

  @observable public environment: "Development" | "Test" | "Production";
  @observable public token: string;
  @observable public tenant: string;
  @observable public highlightColor: string;
  @observable public instance: IInstance;
  @observable public isMobile: boolean;
  @observable public styles: React.CSSProperties;
  @observable public fontSlots: IFontSlots;

  @observable public showContentMap: boolean;
  @observable public showContentMapContent: boolean;

  @observable public hasLoaded: boolean;
  @observable public hidden: boolean;
  @observable public currentUrl: string;

} 